export class BuildCommonCustomerIntelligenceArea {
    /** CI Area for general telemetry */
    public static BUILDCOMMON: string = "BuildCommon";
}


export class CustomerIntelligenceBuildLinking {
    public static OPEN_LINKED_BUILD = "OPEN_BUILD_LINK";
    public static LINKED_WORK_ITEM_BUILDS = "LINKED_WORK_ITEM_BUILDS";
}
